"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishModal = exports.SankeyDevMenuPublishItem = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const SankeyDevMenuPublishItem = (t, dict_hook_ref_setter_show_dialog_components) => {
    return react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'publish', placement: 'bottom', rootClose: true, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-publish' },
            t('Menu.tooltips.publish'),
            " ") },
        react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', onClick: () => dict_hook_ref_setter_show_dialog_components.ref_setter_show_publish_dialog.current(true) },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { position: 'absolute', top: '2.2rem', fontSize: '0.4rem' } }, "Dev"),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faShareFromSquare })),
            react_1.default.createElement(react_bootstrap_1.Col, { className: 'textIcon' }, t('Menu.pub'))));
};
exports.SankeyDevMenuPublishItem = SankeyDevMenuPublishItem;
/**
   * Description placeholder
   *
   * @param {PublishModalTypes} { publishImpl,set_ref_setter_show_publish_dialog,file_path_initial }
   * @returns
   */
const PublishModal = ({ t, publishImpl, dict_hook_ref_setter_show_dialog_components, data }) => {
    const [show_modal_publish, set_show_modal_publish] = (0, react_1.useState)(false);
    dict_hook_ref_setter_show_dialog_components.ref_setter_show_publish_dialog.current = set_show_modal_publish;
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: show_modal_publish, onHide: () => set_show_modal_publish(false) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, t('Menu.pdd'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, null, t('Menu.ca')),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', placeholder: data.file_name ? data.file_name : '', onChange: (evt) => data.file_name = evt.target.value }))))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => publishImpl(data.file_name) }, t('Menu.pub')),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: () => set_show_modal_publish(false) }, t('Menu.ca')))));
};
exports.PublishModal = PublishModal;
